import * as BasketUpdated from '@ori-events/basket-updated';
import { useEffect } from 'react';

export const useBasketUpdated = (callback: (event: BasketUpdated.Data) => void) => {
  useEffect(() => {
    const listener = ((event: BasketUpdated.Event) => callback(event.detail)) as EventListener;
    window.addEventListener(BasketUpdated.Name, listener);

    return () => window.removeEventListener(BasketUpdated.Name, listener);
  }, [callback]);
};
